export default __webpack_public_path__ + "static/media/analystIcon.27ef0f03.png";